import { render, staticRenderFns } from "./LinkableLabel.vue?vue&type=template&id=3bc63e0e&scoped=true"
import script from "./LinkableLabel.vue?vue&type=script&lang=ts"
export * from "./LinkableLabel.vue?vue&type=script&lang=ts"
import style0 from "./LinkableLabel.vue?vue&type=style&index=0&id=3bc63e0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc63e0e",
  null
  
)

export default component.exports